import { requestApi } from "../funcitons";

export default {
    // Device Groups
    getDeviceGroups: async () => {
        const res = await requestApi('devices/groups', 'GET');
        return res.data;
    },
    getDeviceGroup: async (id) => {
        const res = await requestApi(`devices/groups/${id}`, 'GET');
        return res.data;
    },
    createDeviceGroup: async (name, description) => {
        const res = await requestApi('devices/groups', 'POST', { name, description });
        return res.data;
    },
    updateDeviceGroup: async (id, name, description) => {
        const res = await requestApi(`devices/groups/${id}`, 'PUT', { name, description });
        return res.data;
    },
    deleteDeviceGroup: async (id) => {
        const res = await requestApi(`devices/groups/${id}`, 'DELETE');
        return res.data;
    },

    // Devices
    getDevices: async () => {
        const res = await requestApi('devices', 'GET');
        return res.data;
    },
    getDevice: async (id) => {
        const res = await requestApi(`devices/${id}`, 'GET');
        return res.data;
    },
    createDevice: async (name, description, device_group_id, project_id) => {
        const res = await requestApi('devices', 'POST', { name, description, device_group_id, project_id });
        return res.data;
    },
    updateDevice: async (id, name, description, device_group_id, project_id) => {
        const res = await requestApi(`devices/${id}`, 'PUT', { name, description, device_group_id, project_id });
        return res.data;
    },
    deleteDevice: async (id) => {
        const res = await requestApi(`devices/${id}`, 'DELETE');
        return res.data;
    },
};

